
export default {
  data() {
    return {
      news: {},
      breadCrumbItems: [
        {
          label: 'Home Page',
          to: {
            path: "/"
          }
        },
        {
          label: "Blogs",
          to: {
            path: "/blog/list"
          }
        }
      ]
    }
  },
  computed: {
    pageTitle() {
      return this.news.htmlTitle || this.news.title + ' - Hirey'
    },
    pageDescription() {
      return this.news.htmlDescription + ' - Hirey' || this.news.subtitle + ' - Hirey'
    }
  },
  async fetch() {
    const serverUrl = 'https://hirey.com/'
    // const serverUrl = 'http://54.70.186.118:82/'
    this.news = (await this.$axios.get(serverUrl + 'server/news?' + new URLSearchParams({
      id: this.$route.params.id,
      type: 'published'
    }))).data.result.news
    try {
      this.news.content = JSON.parse(this.news.content)
    } catch (e) {
      this.news.content = {}
    }
    this.breadCrumbItems.push({
      label: this.news.title.substr(0,20)+"..."
    })
  },
  head() {
    return {
      title: this.pageTitle,
      meta: [
        {hid: 'description', name: 'description', content: this.pageDescription},
        {hid: 'twitter:card', name: 'twitter:card', content: 'summary_large_image'},
        {hid: 'twitter:title', name: 'twitter:title', content: this.pageTitle},
        {hid: 'twitter:description', name: 'twitter:description', content: this.pageDescription},
        {hid: 'twitter:image', name: 'twitter:image', content: this.news.headUrl},
        {hid: 'og:image', property: 'og:image', content: this.news.headUrl},
      ],
    }
  },
};
